export default __webpack_public_path__ + "static/media/online-marketing.de94c275.svg";